import { Button, Container, Eyebrow, hexToRgba, scrollToId } from './primitives'
import { PreviewSarah } from './gallery'

const ACCENT = '#7a1f2b'
const HEADLINE = 'A site that closes the retainer for you.'

const STATS = [
  { k: '7 days', v: 'Brief to live domain' },
  { k: '$1,999', v: 'Flat, no add-ons' },
  { k: '0', v: 'Sales calls required' },
] as const

export function Hero() {
  const words = HEADLINE.split(' ')
  const blobA = `radial-gradient(closest-side, ${hexToRgba(ACCENT, 0.22)}, transparent 70%)`
  const blobB = `radial-gradient(closest-side, ${hexToRgba(ACCENT, 0.14)}, transparent 70%)`

  return (
    <section
      className="hero"
      style={{ position: 'relative', overflow: 'hidden' }}
    >
      <div
        aria-hidden
        style={{ position: 'absolute', inset: 0, pointerEvents: 'none', overflow: 'hidden' }}
      >
        <div
          className="hero-drift-a"
          style={{
            position: 'absolute',
            top: '-20%',
            left: '-10%',
            width: '70%',
            height: '130%',
            background: blobA,
            filter: 'blur(40px)',
            animation: 'hero-drift-a 22s ease-in-out infinite',
            willChange: 'transform',
          }}
        />
        <div
          className="hero-drift-b"
          style={{
            position: 'absolute',
            top: '-10%',
            right: '-15%',
            width: '65%',
            height: '120%',
            background: blobB,
            filter: 'blur(50px)',
            animation: 'hero-drift-b 30s ease-in-out infinite',
            willChange: 'transform',
          }}
        />
      </div>

      <Container
        className="hero-inner"
        style={{ position: 'relative' }}
      >
        <div
          className="hero-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 1fr) 280px',
            alignItems: 'end',
            gap: 56,
          }}
        >
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <span
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: '50%',
                  background: 'var(--accent)',
                  display: 'inline-block',
                }}
              />
              <Eyebrow>Vello, for fractional executives</Eyebrow>
            </div>
            <h1
              className="hero-headline"
              style={{
                fontFamily: 'var(--serif)',
                fontSize: 'clamp(44px, 7vw, 104px)',
                lineHeight: 0.95,
                letterSpacing: '-0.025em',
                fontWeight: 400,
                margin: '24px 0 0',
                textWrap: 'balance',
              }}
            >
              {words.map((w, i) => {
                if (i === words.length - 1) {
                  return (
                    <span key={i} style={{ color: 'var(--accent)', fontStyle: 'italic' }}>
                      {w}
                    </span>
                  )
                }
                return <span key={i}>{w} </span>
              })}
            </h1>
            <p
              style={{
                maxWidth: 560,
                fontSize: 18,
                lineHeight: 1.55,
                color: 'var(--muted)',
                margin: '28px 0 0',
              }}
            >
              Custom site, designed and built for fractional executives. Live in 7 days.{' '}
              <span style={{ color: 'var(--fg)', fontWeight: 500 }}>$1,999</span>, flat.
            </p>
            <div
              className="hero-cta-row"
              style={{
                display: 'flex',
                gap: 12,
                marginTop: 32,
                alignItems: 'center',
                flexWrap: 'wrap',
              }}
            >
              <Button variant="primary" size="lg" onClick={() => scrollToId('pricing')}>
                Start your site <span style={{ opacity: 0.5 }}>→</span>
              </Button>
              <a
                href="#work"
                className="btn-ghost"
                style={{
                  fontSize: 14,
                  color: 'var(--fg)',
                  padding: '15px 18px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 6,
                  border: '1px solid var(--line-strong)',
                  borderRadius: 2,
                  transition: 'all 150ms ease',
                }}
              >
                See work <span style={{ opacity: 0.5 }}>→</span>
              </a>
            </div>
            <div
              style={{
                marginTop: 20,
                fontSize: 13,
                color: 'var(--muted)',
                fontFamily: 'var(--mono)',
                letterSpacing: '0.04em',
              }}
            >
              7-DAY TURNAROUND · NO CALLS · STRIPE CHECKOUT
            </div>
          </div>

          <aside
            className="hero-stats"
            aria-hidden
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 20,
              paddingLeft: 28,
              borderLeft: '1px solid var(--line-strong)',
            }}
          >
            {STATS.map((s) => (
              <div key={s.v}>
                <div
                  style={{
                    fontFamily: 'var(--serif)',
                    fontSize: 40,
                    lineHeight: 1,
                    letterSpacing: '-0.02em',
                    fontWeight: 400,
                  }}
                >
                  {s.k}
                </div>
                <div
                  style={{
                    marginTop: 6,
                    fontSize: 12,
                    fontFamily: 'var(--mono)',
                    letterSpacing: '0.06em',
                    color: 'var(--muted)',
                    textTransform: 'uppercase',
                  }}
                >
                  {s.v}
                </div>
              </div>
            ))}
          </aside>
        </div>

        <div style={{ marginTop: 72, position: 'relative' }}>
          <div
            style={{
              border: '1px solid var(--line)',
              borderRadius: 4,
              background: '#fff',
              overflow: 'hidden',
              boxShadow:
                '0 40px 80px -40px rgba(10,10,10,0.25), 0 8px 24px -12px rgba(10,10,10,0.08)',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '10px 14px',
                borderBottom: '1px solid var(--line)',
                background: '#F4F4F0',
              }}
            >
              <div style={{ display: 'flex', gap: 6 }}>
                <div
                  style={{ width: 10, height: 10, borderRadius: '50%', background: '#E2E2DC' }}
                />
                <div
                  style={{ width: 10, height: 10, borderRadius: '50%', background: '#E2E2DC' }}
                />
                <div
                  style={{ width: 10, height: 10, borderRadius: '50%', background: '#E2E2DC' }}
                />
              </div>
              <div
                style={{
                  flex: 1,
                  display: 'flex',
                  alignItems: 'center',
                  fontFamily: 'var(--mono)',
                  fontSize: 12,
                  lineHeight: 1,
                  color: 'var(--muted)',
                  paddingLeft: 8,
                }}
              >
                sarahchen.co
              </div>
            </div>
            <PreviewSarah />
          </div>
        </div>
      </Container>
    </section>
  )
}
